<template>
  <div>
    <Hero
      subheadline="Ferienwohnung Landliebe"
      headline="Nimm dir Zeit, glücklich zu sein"
      :src="images.fewo[0].src"
    />
    <section id="intro" class="wrapper mt-12 sm:mt-20">
      <!-- <img class="mx-auto w-32" :src="getImgUrl(images.stars)" alt="" /> -->
      <h1 class="text-center leading-snug font-serif mt-2">
        Ferienwohnung Landliebe
      </h1>
      <p class="intro max-w-4xl mx-auto pt-6 pb-6">
        Die Ferienwohnung ist liebevoll und gemütlich eingerichtet und wurde
        regelmäßig renoviert und modernisiert.
        <!-- Bis Ende 2024 war die
        Ferienwohnung mit
        <a
          class="hover:text-yellow-700"
          href="https://www.deutschertourismusverband.de/qualitaet/sterneunterkuenfte/fuer-gaeste.html"
          target="_blank"
          >vier Sternen</a
        >
        nach DTV, sowie als wanderfreundlich und fahrradfreundlich
        ausgezeichnet.  -->
        Vergessen Sie den Alltag und fühlen Sie sich bei behaglicher Atmosphäre
        rundum wohl! Unsere Ferienwohnung lädt Sie herzlich dazu ein. In ruhiger
        sonniger Lage genießen Sie einen besonderen Schwarzwald Urlaub. Wir
        freuen uns auf Sie!
      </p>
      <Quote :text="quotes.first.text" :author="quotes.first.author" />
    </section>

    <section id="images" class="bg-gray-900 mt-24 mx-auto px-4">
      <div class="container max-w-6xl mx-auto pt-16 pb-24">
        <h2 class="text-center text-gray-100">Bilder</h2>
        <ImageGallery :images="images.fewo" class="mt-8" />
      </div>
    </section>

    <section id="details" class="bg-gray-100">
      <div class="container pt-16 pb-24 max-w-4xl mx-auto px-4">
        <h2 class="text-center leading-snug">Ausstattung & Service</h2>
        <p class="pt-4 pb-6">
          In unserer liebevoll eingerichteten Ferienwohnung Landliebe finden Sie
          alles, was Sie für einen entspannten Urlaub brauchen. Das Mitbringen
          von Haustieren ist leider nicht möglich, da es sich bei unserer
          Ferienwohnung um eine allergikerfreundliche Unterkunft handelt.
        </p>
        <div
          class="flex flex-col sm:flex-row justify-between leading-10 sm:leading-7 text-center sm:text-left sm:text-lg text-xl"
        >
          <ul class="font-bold">
            <li class="py-1"><span class="pr-2">✔️</span>Kostenloses W-Lan</li>
            <li class="py-1"><span class="pr-2">✔️</span>Satelliten TV</li>
            <li class="py-1"><span class="pr-2">✔️</span>Internetzugang</li>
            <li class="py-1"><span class="pr-2">✔️</span>HiFi Anlage</li>
          </ul>

          <ul class="font-bold">
            <li class="py-1"><span class="pr-2">✔️</span>Mikrowelle</li>
            <li class="py-1"><span class="pr-2">✔️</span>Backofen</li>
            <li class="py-1"><span class="pr-2">✔️</span>Geschirrspüler</li>
            <li class="py-1"><span class="pr-2">✔️</span>Kühlschrank</li>
            <li class="py-1"><span class="pr-2">✔️</span>Kaffeemaschine</li>
            <li class="py-1"><span class="pr-2">✔️</span>Wasserkocher</li>
            <li class="py-1"><span class="pr-2">✔️</span>Toaster</li>
          </ul>

          <ul class="font-bold">
            <li class="py-1"><span class="pr-2">✔️</span>Erdgeschoss</li>
            <li class="py-1"><span class="pr-2">✔️</span>Einbauküche</li>
            <li class="py-1"><span class="pr-2">✔️</span>1 Schlafraum</li>
            <li class="py-1"><span class="pr-2">✔️</span>Schlafcouch</li>
          </ul>

          <ul class="font-bold">
            <li class="py-1"><span class="pr-2">✔️</span>Dusche</li>
            <li class="py-1"><span class="pr-2">✔️</span>Kosmetikspiegel</li>
            <li class="py-1"><span class="pr-2">✔️</span>Föhn</li>
            <li class="py-1">
              <span class="pr-2">✔️</span>Handtücher vorhanden
            </li>
            <li class="py-1">
              <span class="pr-2">✔️</span>Bettwäsche vorhanden
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section id="plan" class="pt-16">
      <h2 class="text-center">Grundriss</h2>
      <ImageGallery
        class="mt-8 max-w-4xl mx-auto"
        :single="true"
        :image="images.grundriss"
      />
    </section>

    <section id="price" class="mt-20 max-w-4xl mx-auto px-4">
      <h2 class="text-center">Preise</h2>

      <ul class="mt-8">
        <li>
          <h4 class="pl-4 text-xl sm:text-2xl text-gray-700 py-4">
            <strong>Regulär</strong> (ab 3 Übernachtungen)
          </h4>
        </li>
        <li class="flex bg-gray-100 py-2 flex-col sm:flex-row">
          <p class="pl-4 w-64"><strong>70,00€</strong> / Nacht</p>
          <p class="pl-4 sm:pl-0">bis 2 Personen</p>
        </li>
        <li class="flex py-2 flex-col sm:flex-row">
          <p class="pl-4 w-64"><strong>5,00€</strong> / Nacht</p>
          <p class="pl-4 sm:pl-0">jede weitere Person</p>
        </li>
        <li class="flex bg-gray-100 py-2 flex-col sm:flex-row">
          <p class="pl-4 w-64"></p>
          <p class="pl-4 sm:pl-0">zzgl. Kurtaxe</p>
        </li>
      </ul>

      <ul class="mt-8">
        <li>
          <h4 class="pl-4 text-xl sm:text-2xl text-gray-700 py-4">
            <strong>Kurzaufenthalt</strong> (1-3 Übernachtungen)
          </h4>
        </li>
        <li class="flex bg-gray-100 py-2 flex-col sm:flex-row">
          <p class="pl-4 w-64"><strong>85,00€</strong> / Nacht</p>
          <p class="pl-4 sm:pl-0">bis 2 Personen</p>
        </li>
        <li class="flex py-2 flex-col sm:flex-row">
          <p class="pl-4 w-64"><strong>5,00€</strong> / Nacht</p>
          <p class="pl-4 sm:pl-0">jede weitere Person</p>
        </li>
        <li class="flex bg-gray-100 py-2 flex-col sm:flex-row">
          <p class="pl-4 w-64"></p>
          <p class="pl-4 sm:pl-0">zzgl. Kurtaxe</p>
        </li>
      </ul>

      <ul class="mt-8">
        <li>
          <h4 class="pl-4 text-xl sm:text-2xl text-gray-700 pt-4">
            <strong>Neu: Kurtaxe</strong> ab 01.01.2027
          </h4>
        </li>
        <li class="pl-4 pt-2 pb-4">
          Im Preis der Kurtaxe ist die kostenlose Nutzung der öffentlichen
          Verkehrsmittel in unserer Region inbegriffen. Weitere Informationen
          finden Sie
          <a
            class="text-red-500"
            href="https://www.schwarzwaldregion-belchen.de/eip/pages/kurtaxe.php"
            target="_blank"
            ><strong>hier</strong></a
          >.
        </li>
        <li class="flex bg-gray-100 py-2 flex-col sm:flex-row">
          <p class="pl-4 w-64"><strong>2,80€</strong> / Tag</p>
          <p class="pl-4 sm:pl-0">Erwachsene u. Jugendliche (ab 16 Jahren)</p>
        </li>
        <li class="flex py-2 flex-col sm:flex-row">
          <p class="pl-4 w-64"><strong>1,40€</strong> / Tag</p>
          <p class="pl-4 sm:pl-0">Kinder (6 bis 15 Jahre)</p>
        </li>
        <li class="flex bg-gray-100 py-2 flex-col sm:flex-row">
          <p class="pl-4 w-64"><strong>Frei</strong></p>
          <p class="pl-4 sm:pl-0">Kinder bis 6 Jahre</p>
        </li>
      </ul>

      <ul class="mt-8">
        <li>
          <h4 class="pl-4 text-xl sm:text-2xl text-gray-700 pt-4">
            <strong>Kurtaxe</strong> (bis 31.12.2026)
          </h4>
        </li>
        <li class="pl-4 pt-2 pb-4">
          Im Preis der Kurtaxe ist die kostenlose Nutzung der öffentlichen
          Verkehrsmittel in unserer Region inbegriffen. Weitere Informationen
          finden Sie
          <a
            class="text-red-500"
            href="https://www.schwarzwaldregion-belchen.de/eip/pages/kurtaxe.php"
            target="_blank"
            ><strong>hier</strong></a
          >.
        </li>
        <li class="flex bg-gray-100 py-2 flex-col sm:flex-row">
          <p class="pl-4 w-64"><strong>2,40€</strong> / Tag</p>
          <p class="pl-4 sm:pl-0">Erwachsene u. Jugendliche (ab 16 Jahren)</p>
        </li>
        <li class="flex py-2 flex-col sm:flex-row">
          <p class="pl-4 w-64"><strong>1,20€</strong> / Tag</p>
          <p class="pl-4 sm:pl-0">Kinder (6 bis 15 Jahre)</p>
        </li>
        <li class="flex bg-gray-100 py-2 flex-col sm:flex-row">
          <p class="pl-4 w-64"><strong>Frei</strong></p>
          <p class="pl-4 sm:pl-0">Kinder bis 6 Jahre</p>
        </li>
      </ul>

      <ul class="mt-8">
        <li>
          <h4 class="pl-4 text-xl sm:text-2xl text-gray-700 pt-4">
            <strong>Storno</strong>
          </h4>
        </li>
        <li class="pl-4 pt-2 pb-4">
          Bei vorzeitiger Abreise oder Stornierung Ihrer Reservierung werden die
          ortsüblichen Stornogebühren berechnet.
        </li>
      </ul>
    </section>
    <section id="occupation" class="bg-gray-100">
      <div class="container mt-20 max-w-4xl mx-auto py-20 px-4">
        <h2 class="text-center">Belegungsplan</h2>
        <iframe
          v-resize="{ scrolling: true }"
          width="100%"
          height="250"
          class="mt-6"
          src="https://www.schwarzwaldregion-belchen.de/accopro/belegtkalender.php?id=308&amp;unit=526&amp;background=white&amp;cols=2&amp;rows=1"
          frameborder="0"
        ></iframe>
      </div>
    </section>
    <section>
      <div class="container max-w-4xl mx-auto pt-16 pb-24">
        <h2 class="text-center">Anreise</h2>
        <p class="intro mt-8">
          Unser Haus liegt zentral in Aitern –
          <span
            class="bg-gray-100 md:text-lg font-semibold text-gray-700 p-1 px-2 rounded"
            >Bergstraße 14, 79677 Aitern</span
          ><br />
          Sie können uns sowohl mit dem Auto, als auch mit dem ÖPNV gut
          erreichen. Gerne holen wir Sie von der Bushaltestelle im Tal ab, wenn
          Sie mit ÖPNV anreisen.
        </p>
        <div class="pt-6">
          <p class="font-bold text-gray-700">Weitere Informationen</p>
          <ul>
            <li>
              <span class="font-bold">🕝 Anreise:</span> Nach 15 Uhr möglich
            </li>
            <li class="pt-1">
              <span class="font-bold">🕙 Abreise:</span> Bis spätestens 10 Uhr
            </li>
            <li class="pt-1">
              <span class="font-bold">💵 Zahlungsart:</span> Ausschließlich
              Barzahlung
            </li>
          </ul>
        </div>
        <div class="flex justify-center">
          <a
            href="https://www.google.com/maps/dir//haus+morgensonne/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x47905554470329d9:0x274f633aeea70357?sa=X&ved=2ahUKEwjjkZOdi-HzAhWHLewKHfjNDgAQ9Rd6BAgJEAQ"
            target="_blank"
          >
            <button
              class="transition-colors duration-200 ease-out bg-red-500 hover:bg-red-700 text-white font-bold text-base py-2 px-4 mt-3 sm:mt-10 rounded"
            >
              Anreise planen
            </button>
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ImageGallery from '../components/ImageGallery.vue'
import Hero from '../components/Hero.vue'
import Quote from '../components/Quote.vue'

export default {
  name: 'Ferienwohnung',
  components: {
    ImageGallery,
    Hero,
    Quote,
  },
  methods: {
    getImgUrl(img) {
      return require(`../assets/${img}`)
    },
    handleScroll(event) {
      if (window.scrollY > 0) {
        this.setDarkNav()
      } else {
        this.setWhiteNav()
      }
    },
    setDarkNav() {
      this.$store.dispatch('setDarkNav')
    },
    setWhiteNav() {
      this.$store.dispatch('setWhiteNav')
    },
  },
  mounted() {
    this.setWhiteNav()
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    this.setDarkNav()
    window.removeEventListener('scroll', this.handleScroll)
  },
  data() {
    return {
      name: 'This is the Imagegallery component',
      quotes: {
        first: {
          text: 'Ein Leben ohne Freude ist wie eine weite Reise ohne Gasthaus',
          author: 'Demokrit',
        },
      },
      images: {
        stars: 'img/stars.png',
        fewo: [
          {
            src: 'img/fewo_landliebe/landliebe-6361.jpeg',
            w: 1440,
            h: 960,
            thumbnail: 'img/fewo_landliebe/thumb/landliebe-6361.jpeg',
          },
          {
            src: 'img/fewo_landliebe/landliebe-6374.jpeg',
            w: 1440,
            h: 960,
            thumbnail: 'img/fewo_landliebe/thumb/landliebe-6374.jpeg',
          },
          {
            src: 'img/fewo_landliebe/landliebe-6368.jpeg',
            w: 1440,
            h: 960,
            thumbnail: 'img/fewo_landliebe/thumb/landliebe-6368.jpeg',
          },
          // {
          //   src: 'img/fewo_landliebe/landliebe-6380.jpeg',
          //   w: 1440,
          //   h: 960,
          //   thumbnail: 'img/fewo_landliebe/thumb/landliebe-6380.jpeg',
          // },
          {
            src: 'img/fewo_landliebe/IMG_7326.jpg',
            w: 1440,
            h: 960,
            thumbnail: 'img/fewo_landliebe/thumb/IMG_7326.jpeg',
          },
          {
            src: 'img/fewo_landliebe/landliebe-6415.jpg',
            w: 1440,
            h: 960,
            thumbnail: 'img/fewo_landliebe/thumb/landliebe-6415.jpeg',
          },
          {
            src: 'img/fewo_landliebe/R6__1235.jpeg',
            w: 1920,
            h: 1280,
            thumbnail: 'img/fewo_landliebe/thumb/R6__1235.jpeg',
          },
          {
            src: 'img/fewo_landliebe/R6__1242.jpeg',
            w: 1920,
            h: 1280,
            thumbnail: 'img/fewo_landliebe/thumb/R6__1242.jpeg',
          },
          {
            src: 'img/fewo_landliebe/R6__1265.jpeg',
            w: 1920,
            h: 1280,
            thumbnail: 'img/fewo_landliebe/thumb/R6__1265.jpeg',
          },
          {
            src: 'img/fewo_landliebe/R6__1230.jpeg',
            w: 1920,
            h: 1280,
            thumbnail: 'img/fewo_landliebe/thumb/R6__1230.jpeg',
          },
        ],
        grundriss: {
          src: 'img/fewo_landliebe/landliebe-grundriss.jpg',
          w: 600,
          h: 335,
          thumbnail: 'img/fewo_landliebe/landliebe-grundriss.jpg',
        },
      },
    }
  },
}
</script>
<style scoped>
a {
  @apply text-yellow-600
            ease-in-out
            duration-150
            transition-colors;
}
strong {
  @apply text-gray-700;
}
iframe {
  width: 1px;
  min-width: 100%;
}
</style>
